import { is } from 'ramda';
import { IEnteredValue } from 'utils/types';

const createOption = (enteredValue: IEnteredValue) => {
  if (is(Object, enteredValue)) {
    return {
      label: enteredValue.name,
      value: enteredValue.id,
    };
  }
  return {
    label: enteredValue,
    value: enteredValue,
  };
};

export const createOptionByKeys = ({
  entity,
  labelKey = 'name',
  valueKey = 'id',
  subtitleKey,
}: {
  entity: Record<string, unknown>;
  labelKey?: string;
  valueKey?: string;
  subtitleKey?: string;
}) => {
  return {
    label: entity?.[labelKey],
    value: entity?.[valueKey],
    ...(subtitleKey && { subtitle: entity?.[subtitleKey] }),
  };
};

export default createOption;
